import type {
  UpsertUserSearchPreferencesMutation,
  UpsertUserSearchPreferencesMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpsertUserSearchPreferencesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useUpsertUserSearchPreferences = createMutationHook({
  // Per-user UI preference — cannot change any register's row count, so it
  // skips the collapsed nav-badge refetch (COI-908). Without this every column
  // reorder or recent-user write would run all 26 counts.
  invalidatesNavCounts: false,
  name: 'upsertUserSearchPreferences',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.userSearchPreferences.upsertUserSearchPreferences.mutationOptions(
      { onSuccess }
    ),
  mapInput: (input: UpsertUserSearchPreferencesMutationVariables) => ({
    ShowGroups: input.ShowGroups,
    FilterByActivePlatformUsers: input.FilterByActivePlatformUsers,
    ShowUserPlatformRole: input.ShowUserPlatformRole,
    ShowUserJobTitle: input.ShowUserJobTitle,
    ShowDirectoryDepartment: input.ShowDirectoryDepartment,
    ShowUserLocation: input.ShowUserLocation,
    ShowUserEmail: input.ShowUserEmail,
    ShowArchivedUsers: input.ShowArchivedUsers,
    ShowInheritedContributors: input.ShowInheritedContributors,
  }),
  invalidate: (trpc) => [
    trpc.frontend.userSearchPreferences.getUserSearchPreferences.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): UpsertUserSearchPreferencesMutation => ({
    insert_user_search_preferences: {
      __typename: 'user_search_preferences_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: UpsertUserSearchPreferencesDocument,
  graphqlVariables: (input) => ({ ...input }),
  evictFields: ['user_search_preferences'],
});
